type AnalyticsEvent = {
  category?: string
  label?: string
  value?: number
  [key: string]: any
}

type PageViewOptions = {
  path?: string
  title?: string
  url?: string
  referrer?: string
  [key: string]: any
}

const isBrowser = typeof window !== "undefined"

const getNavigatorInfo = () => {
  if (!isBrowser) return {}
  const { language, userAgent } = window.navigator
  return { language, userAgent }
}

export const trackEvent = (eventName: string, event: AnalyticsEvent) => {
  if (!isBrowser) return

  const { category, label, value, ...rest } = event

  // Google Analytics 4
  // @ts-ignore-next-line
  if (window.gtag) {
    // @ts-ignore-next-line
    window.gtag("event", eventName, {
      event_category: category,
      event_label: label,
      value,
      ...rest,
    })
  }

  // Segment
  // @ts-ignore-next-line
  if (window.analytics) {
    // @ts-ignore-next-line
    window.analytics.track(eventName, {
      category,
      label,
      value,
      ...rest,
    })
  }
}

export const trackPage = (options: PageViewOptions = {}) => {
  if (!isBrowser) return

  const path = options.path ?? window.location.pathname
  const title = options.title ?? document.title
  const url = options.url ?? window.location.href
  const referrer = options.referrer ?? document.referrer
  const { language, userAgent } = getNavigatorInfo()

  const properties = {
    path,
    title,
    url,
    referrer,
    language,
    userAgent,
    ...options,
  }

  // GA4
  // @ts-ignore-next-line
  if (window.gtag) {
    // @ts-ignore-next-line
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title,
      page_location: url,
      language,
    })
  }

  // Segment
  // @ts-ignore-next-line
  if (window.analytics) {
    // @ts-ignore-next-line
    window.analytics.page(path, properties)
  }
}
